export default "__VITE_ASSET__BX7smRIL__"